module.exports = __webpack_public_path__ + "img/loginmainiconhls.9afc1dea.png";